import { combineReducers } from "redux";
import user from "./user";
import changeUnit from "./unit";

const rootReducer = combineReducers({
    user,
    changeUnit
});

export default rootReducer;